export const TEAM_NAME_MAX_LENGTH = 30

const TEAM_NAME_PATTERN = /^[a-zA-Z0-9\s'-]+$/

export function validateTeamName(name: string, takenNames: string[]): string | undefined {
  if (!name) return 'Name is required'
  if (takenNames.some((taken) => taken.toLowerCase() === name.toLowerCase())) {
    return 'Name is already taken'
  }
  if (name.length > TEAM_NAME_MAX_LENGTH || !TEAM_NAME_PATTERN.test(name)) {
    return `Team name can only contain letters, numbers, spaces, hyphens and apostrophes (max ${TEAM_NAME_MAX_LENGTH} characters)`
  }
}
